export const parsePriceString = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number') {
    return Number.isNaN(value) ? null : value;
  }

  const numericPortion = String(value).replace(/[^0-9.,-]/g, '');
  if (!numericPortion) {
    return null;
  }

  const lastComma = numericPortion.lastIndexOf(',');
  const lastDot = numericPortion.lastIndexOf('.');
  let normalized = numericPortion;

  if (lastComma > lastDot) {
    // Treat comma as decimal separator, dot as thousands separator
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else {
    // Treat dot as decimal separator, remove commas
    normalized = normalized.replace(/,/g, '');
  }

  const parsed = parseFloat(normalized);
  return Number.isNaN(parsed) ? null : parsed;
};

export const createCurrencyFormatter = (locale = 'en-US', currency = 'USD') =>
  new Intl.NumberFormat(locale.replace('_', '-'), {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  });

